/* eslint-disable react-hooks/exhaustive-deps */
import React, { useRef, useMemo, useState, useEffect } from 'react';

import { Grid, Typography, makeStyles } from '@material-ui/core';

import CreateCaseModel from '../../models/CreateCaseModel';
import EditFields from '../common/EditFields';
import SimpleTooltip from '../simpleTooltip/SimpleTooltip';

const useStyles = makeStyles(() => {
  return {
    descriptionTypography: {
      color: '#999999',
      fontSize: '14px',
      fontWeight: 400,
      lineHeight: '24px',
      margin: '8px 0 0',
      textAlign: 'left',
    },
    fieldContainer: {
      paddingTop: '20px',
    },
    fieldEditContainer: {
      marginBottom: '20px',
      marginTop: '4px',
    },
    fieldTitle: {
      color: '#172B4D',
      fontSize: '14px',
      fontWeight: '600',
      lineHeight: '21px',
      marginBottom: '0px',
    },
    onlinePortalContainer: {
      margin: '36px 0px 0px',
    },
  };
});

export default ({ onChangeFormOnlinePortalAccess, status }) => {
  const classes = useStyles();
  const [form, setForm] = useState(status);

  const portalAddressRef = useRef();
  const portalPasswordRef = useRef();
  const portalUsernameRef = useRef();
  const studyNameRef = useRef();

  const portalAddressField = useMemo(
    () => [
      {
        containerClass: classes.fieldEditContainer,
        label: '',
        name: 'portalAddress',
        onChange: (value, isValid) => {
          onChangeFormOnlinePortalAccess(value, 'portalAddress', isValid);
        },
        placeholder: 'Example: my_online_portal.com',
        type: 'text',
        variant: 'standard',
      },
    ],
    []
  );

  const portalPasswordField = useMemo(
    () => [
      {
        containerClass: classes.fieldEditContainer,
        label: '',
        name: 'portalPassword',
        onChange: (value, isValid) => {
          onChangeFormOnlinePortalAccess(value, 'portalPassword', isValid);
        },
        placeholder: '',
        type: 'password',
        variant: 'standard',
      },
    ],
    []
  );

  const portalUsernameField = useMemo(
    () => [
      {
        containerClass: classes.fieldEditContainer,
        label: '',
        name: 'portalUsername',
        onChange: (value, isValid) => {
          onChangeFormOnlinePortalAccess(value, 'portalUsername', isValid);
        },
        placeholder: '',
        type: 'text',
        variant: 'standard',
      },
    ],
    []
  );

  const studyNameField = useMemo(
    () => [
      {
        containerClass: classes.fieldEditContainer,
        label: '',
        name: 'studyName',
        onChange: (value, isValid) => {
          onChangeFormOnlinePortalAccess(value, 'studyName', isValid);
        },
        placeholder: 'Example: Head MRI, October 17, 2021',
        type: 'text',
        variant: 'standard',
      },
    ],
    []
  );

  useEffect(() => {
    setForm(status);
  }, [status]);

  return (
    <div className="text-left">
      {/* The code field */}
      <Grid container>
        <Grid item xs={12}>
          <div className={classes.onlinePortalContainer}>
            <Typography className={classes.fieldTitle}>Allowing Access</Typography>

            <Typography className={classes.descriptionTypography}>
              If you have online access to your radiology images through a website, you can grant Mediphany access by providing the website login address and your login credentials
              so we can access the images and create a video report on your behalf.
            </Typography>

            <Typography className={classes.descriptionTypography} style={{ marginTop: '2px' }}>
              If you are not comfortable with this method then please choose one of the other options to allow mediphany to view your images.
            </Typography>
          </div>
        </Grid>

        <Grid item xs={12} lg={10} xl={8}>
          <Grid container>
            <Grid item xs={12} md={8} className={classes.fieldContainer}>
              <div>
                <Typography className={classes.fieldTitle}>
                  <span style={{ color: '#E92828' }}>*</span> Online Portal URL
                </Typography>
              </div>

              <EditFields
                validate={CreateCaseModel.validateOnlinePortalAccess}
                data={form.formOnlinePortalAccess}
                labelClass={classes.labels}
                labelPosition="top"
                useAutoFocus={false}
                ref={portalAddressRef}
                fields={portalAddressField}
              />
            </Grid>
            <Grid item xs={12} md={8} className={classes.fieldContainer}>
              <div>
                <Typography className={classes.fieldTitle}>
                  <span style={{ color: '#E92828' }}>*</span> Username
                </Typography>
              </div>

              <EditFields
                validate={CreateCaseModel.validateOnlinePortalAccess}
                data={form.formOnlinePortalAccess}
                labelClass={classes.labels}
                labelPosition="top"
                useAutoFocus={false}
                ref={portalUsernameRef}
                fields={portalUsernameField}
              />
            </Grid>
            <Grid item xs={12} md={8} className={classes.fieldContainer}>
              <Grid container alignItems="center">
                <Grid item>
                  <Typography className={classes.fieldTitle}>
                    <span style={{ color: '#E92828' }}>*</span> Password
                  </Typography>
                </Grid>

                <Grid item style={{ marginLeft: '8px' }}>
                  <SimpleTooltip wide title="We suggest changing your online portal password after we have produced your video report for you." />
                </Grid>
              </Grid>

              <EditFields
                validate={CreateCaseModel.validateOnlinePortalAccess}
                data={form.formOnlinePortalAccess}
                labelClass={classes.labels}
                labelPosition="top"
                useAutoFocus={false}
                ref={portalPasswordRef}
                fields={portalPasswordField}
              />
            </Grid>
            <Grid item xs={12} md={8} className={classes.fieldContainer}>
              <div>
                <Typography className={classes.fieldTitle}>
                  <span style={{ color: '#E92828' }}>*</span> Study Description
                </Typography>
              </div>

              <EditFields
                validate={CreateCaseModel.validateOnlinePortalAccess}
                data={form.formOnlinePortalAccess}
                labelClass={classes.labels}
                labelPosition="top"
                useAutoFocus={false}
                ref={studyNameRef}
                fields={studyNameField}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
};
